<template>
  <div class="aboutBw" id="news">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="head bg-img-maintain">
          <img :src="textData.img">
          <div class="title animation">{{textData.title}}</div>
          <div class="content animation">{{textData.describe}}</div>
        </div>
      </div>
      <div class="step2" data-step="b">
        <div class="bw-content-first" >
            <div class="animation" v-show="show1">
              <div class="bw-content-first-child">
                <div class="bw-content-first-child-left">
                  <img :src="bwData.img"/>
                </div>
                <div class="bw-content-first-child-right">
                  <div class="bw-content-first-child-right-text">
                    <div class="fnt-title">{{bwData.title}}</div>
                    <div class="fnt-content">
                      {{bwData.describe1}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="step3" data-step="c">
        <div class="qualifications" v-show="show2">
          <div class="fnt-32-bold animation animationToBottom first-level-title" >
            资质荣誉
          </div>
          <div class="animation content">
            <el-carousel v-model="currentSlide" ref="myCarousel" :drag="true" :show-arrow="false" :autoplay="false" indicator-position="none" :loop="false">
              <el-carousel-item v-for="(item,index) in qualifications" :key="index">
                <div class="content">
                  <div class="item" v-for="(item2,index2) in qualifications[index]" :key="index2" :style="{ backgroundImage: `url(${item2.img})` }">
                    <div class="secondary-title ">{{ item2.describe1 }}</div>
                    <div class="secondary-title ">{{ item2.describe2 }}</div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="step4" data-step="d">
        <footer-item class="animation"></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../home/components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      show1: false,
      show2: false,
      dataList: [1, 2, 3, 4, 5, 6, 7, 8],
      currentSlide: 0,
      qualifications: [],
      textData: {},
      bwData: {}
    }
  },
  methods: {
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step2':
          this.show1 = true
          break
        case 'step3':
          this.show2 = true
          break
        case 'step4':
          this.show3 = true
          break
        case 'step5':
          this.show4 = true
          break
      }
    }
  },
  created: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page501.g501[5]
      let list = [...this.$boss.page511.g511]
      this.bwData = this.$boss.page511.g511[this.$boss.page511.g511.length - 1]
      let dataList = list.slice(0, this.$boss.page511.g511.length - 1).reverse()
      for (let i = 0; i < dataList.length; i += 4) {
        this.qualifications.push(dataList.slice(i, i + 4))
      }
      console.log('this.$boss.page511.g511', this.qualifications)
    }
  }
}
</script>
<style scoped lang="less">
.aboutBw{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  //一级标题
  .first-level-title {
    font-size: 42px;
    font-weight: bold;
    color: #323232;
  }

  //二级标题
  .secondary-title {
    font-size: 24px;
    font-weight: bold;
    color: #323232;
  }

  //正文
  .text {
    font-size: 20px;
    color: #323232;
    margin-top: 70px;
  }
  div{
    //背景图宽度保持不变类
    .bg-img-maintain{
      background-size: cover !important;
      background-position: center !important;
    }
    .head{
      display: flex;
      flex-direction: column;
      align-items: baseline;
      height: 71vh;
      img {
        width: 100%;
        height: 100%;
      }
      .title {
        font-size: 52px;
        opacity: 0;
        margin-top: -45vh;
        font-weight: bold;
        color: #fff;
        padding-left: 100px;
      }

      .content {
        padding-left: 100px;
        font-size: 32px;
        opacity: 0;
        margin-top: 40px;
        color: #E6E9F3;
      }
      .el-button {
        width: 200px;
        height: 60px;
        margin-top: 100px;
        color: #E6E9F3;
        background-color: transparent;
        border: 1px solid #E6E9F3;
        font-size: 18px;
      }
    }
    .bw-content-first {
      // height: 76vh;
      width: 100%;
      &-child{
        width: calc(100% - 200px);
        /*height: 600px;*/
        text-align: left;
        padding: 100px;
        display: flex;
        &-left{
          /*max-width: 651px;*/
          width: 50%;
          height: 55vh;
          img {
            width: 100%;
            height: 100%;
            // height: 80vh;
            /*min-height: 760px;*/
          }
        }
        &-right {
          width: 50%;
          /*max-width: calc(100% - 651px);*/
          padding: 0 0 0 10%;
          display: table;
          height: 55vh;
          &-text {
            display: table-cell;
            vertical-align: middle;
            // height: 60vh;
            .fnt-title {
              font-size: 32px;
              font-weight: bold;
            }
            .fnt-content {
              color: #323232;
              padding: 50px 0;
              font-size: 20px;
              line-height: 36px;
              letter-spacing: 2px;
            }
          }
        }
        img:hover {
          transform: scale(1.05);
        }
      }
    }
    .qualifications{
      min-height: 863px;
      width: 100%;
      background: url("../../../static/images/aboutUs/aboutBw/bg.png") no-repeat;
      background-size: 100% 100%;
      .fnt-32-bold{
        color:#fff;
      }
      .content{
        height: 718px;
        margin-top:70px;
        text-align:left;
        display:flex;
        /*justify-content:space-between;*/
        padding: 0 40px;
        /deep/.el-carousel{
          width:100%;
        }
        /deep/.el-carousel__container{
          height:100%;
        }
        .item{
          height:530px;
          width:25%;
          padding: 50px;
          box-sizing: border-box;
          background-size: 100% 100%;
          // background: url("../../../static/images/aboutUs/qualificationHonor/icon1.png") no-repeat;

        }
        .item:hover {
          transform: scale(1.05);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs/aboutBw/index.vue